<template>
  <div id="app">
    <navbar>..</navbar>
    <router-view :key="$route.fullPath"/>
    <st00pka>..</st00pka>
  </div>
</template>

<script>
import navbar from "@/components/navbar.vue"
import st00pka from "@/components/st00pka.vue"

export default {
  components:{
  navbar,
  st00pka
  },
  watch: {
      '$route':{
        handler: function(to) {
          document.title = to.meta.title || 'HentaiHaven.pl'
        },
         immediate: true
      }
    },
    methods: {
      track() {
        this.$ga.page('/')
      }
    }
}
</script>
